import imgBracketsMetalicos from "../images/img_blog/brackets-mealicos.png";
import imgBracketsEsteticos from "../images/img_blog/brackets-esteticos.png";
import imgInvisalign from "../images/img_blog/invisalign.png";
import imgCuscoBrackets from "../images/img_blog/cusco-brackets.png";
import imgCuidadoBrackets from "../images/img_blog/cuidado-brackets.png";
import imgJovenOrtodoncia from "../images/img_blog/joven-ortodoncia.png";
import imgKidsOrtho from "../images/img_blog/kids_ortho.webp";
import imgNinosOrtodoncia from "../images/img_blog/niños-ortodoncia.png";
import imgOrtodonciaCusco from "../images/img_blog/ortodoncia-cusco.jpg";
import imgOrtopediaMaxilar from "../images/img_blog/ortopedia-maxilar.png";
import imgFilosofia from "../images/img_blog/img_filosofia.png";
import imgRetenedores from "../images/img_blog/retenedores.png";
import imgSensibilidad from "../images/sensibilidad-dental.png";

export const blogPosts = [
  {
    slug: "ortodoncia-temprana-ninos",
    coverImage: imgKidsOrtho,
    locale: "es",
    serviceFocus: ["orthodontics"],
    title: "Ortodoncia en edades tempranas: por qué no conviene esperar",
    date: "2026-07-19",
    readTime: "6 min",
    excerpt:
      "Detectar y tratar a tiempo problemas de mordida y crecimiento maxilar en niños puede acortar el tratamiento futuro y evitar complicaciones. Te explico por qué la ortodoncia temprana marca la diferencia.",
    seoTitle: "Ortodoncia temprana en niños Cusco | Beneficios | Smile Up",
    seoDescription:
      "Por qué hacer ortodoncia en edades tempranas: beneficios, señales de alerta y primera evaluación alrededor de los 7 años. Ortodoncia infantil en Cusco.",
    coverTheme: "mint",
    content: [
      {
        type: "p",
        text: "Muchos padres piensan que la ortodoncia «solo es para adolescentes». En realidad, la primera evaluación ortodóncica se recomienda cerca de los 7 años. Actuar en edades tempranas no significa poner brackets a todos los niños: significa detectar a tiempo qué problemas conviene corregir mientras el hueso aún está en crecimiento.",
      },
      { type: "h3", text: "¿Por qué importa intervenir temprano?" },
      {
        type: "p",
        text: "En la infancia los maxilares son más moldeables. Eso permite guiar el crecimiento, ampliar el paladar, corregir mordidas cruzadas y crear espacio para los dientes permanentes con aparatos más simples y tiempos más cortos que si se espera a que el problema se consolide en la adolescencia o en la adultez.",
      },
      {
        type: "ul",
        items: [
          "Aprovechar el crecimiento óseo para corregir desarmonías de maxilar y mandíbula.",
          "Reducir el riesgo de apiñamiento severo o de extracciones futuras.",
          "Mejorar la función al masticar, hablar y respirar por la nariz.",
          "Evitar desgaste dental, dolor articular o asimetrías que se agravan con los años.",
          "Facilitar una segunda fase (brackets o alineadores) más corta y predecible, si hace falta.",
        ],
      },
      { type: "h3", text: "Señales de que tu hijo debería evaluarse ya" },
      {
        type: "ul",
        items: [
          "Dientes de leche que no caben, se apiñan o se pierden muy pronto.",
          "Mordida cruzada (los dientes de abajo «por fuera» de los de arriba).",
          "Dificultad para cerrar los labios, respiración bucal o ronquidos.",
          "Chuparse el dedo o usar chupón más allá de la edad esperada.",
          "Mentón muy adelantado o muy retrasado respecto al resto de la cara.",
          "Dientes permanentes que erupcionan torcidos o sin espacio.",
        ],
      },
      { type: "h3", text: "Evaluar no siempre significa tratar de inmediato" },
      {
        type: "p",
        text: "En la primera consulta revisamos la mordida, el espacio disponible y el patrón de crecimiento. Algunos niños solo necesitan controles periódicos; otros se benefician de ortopedia maxilar o de una fase interceptiva corta. La clave es no llegar tarde a un problema que, visto a tiempo, tiene una solución más sencilla.",
      },
      {
        type: "note",
        text: "En Smile Up (Cusco) recomendamos una evaluación ortodóncica alrededor de los 7 años, aunque no veas un «problema obvio». Una revisión temprana da tranquilidad y, cuando hace falta, abre la puerta a un tratamiento más efectivo.",
      },
    ],
  },
  {
    slug: "brackets-metalicos-cusco",
    coverImage: imgBracketsMetalicos,
    locale: "es",
    serviceFocus: ["orthodontics"],
    title: "Brackets metálicos en Cusco: cuándo elegirlos y qué esperar",
    date: "2026-06-08",
    readTime: "5 min",
    excerpt:
      "Los brackets metálicos siguen siendo una de las opciones más efectivas en ortodoncia. Te explico sus ventajas, duración y cuidados en Cusco.",
    seoTitle: "Brackets metálicos en Cusco | Ortodoncia fija | Smile Up",
    seoDescription:
      "Guía sobre brackets metálicos en Cusco: indicaciones, ventajas, tiempos de tratamiento y cuidados. Ortodoncia para niños, jóvenes y adultos con el Dr. Paniura.",
    coverTheme: "sky",
    content: [
      {
        type: "p",
        text: "Los brackets metálicos son el sistema fijo más utilizado en ortodoncia. En Smile Up los indico cuando se necesita un control preciso de la mordida, la alineación dental o movimientos complejos en niños, adolescentes y adultos.",
      },
      { type: "h3", text: "Ventajas de los brackets metálicos" },
      {
        type: "ul",
        items: [
          "Alta eficacia en casos de apiñamiento, diastemas y mordidas cruzadas.",
          "Resistentes y adecuados para tratamientos largos.",
          "Opción económica frente a brackets estéticos o alineadores en muchos casos.",
          "Permiten el uso de elásticos, microimplantes y otros auxiliares cuando el plan lo requiere.",
        ],
      },
      { type: "h3", text: "¿Cuánto dura el tratamiento?" },
      {
        type: "p",
        text: "La duración depende de la complejidad del caso. Muchos tratamientos duran entre 18 y 24 meses, con controles cada 4 a 6 semanas. En la evaluación inicial te indico un calendario realista según tu diagnóstico.",
      },
      {
        type: "note",
        text: "Los brackets metálicos no son «solo para niños». Cada vez más adultos en Cusco eligen esta opción por su eficacia y predictibilidad.",
      },
    ],
  },
  {
    slug: "brackets-esteticos-cusco",
    coverImage: imgBracketsEsteticos,
    locale: "es",
    serviceFocus: ["orthodontics"],
    title: "Brackets estéticos en Cusco: ortodoncia discreta con la misma eficacia",
    date: "2026-06-05",
    readTime: "5 min",
    excerpt:
      "Brackets cerámicos o de zafiro: menos visibles que los metálicos, ideales si buscas discreción sin renunciar a un tratamiento fijo.",
    seoTitle: "Brackets estéticos en Cusco | Brackets cerámicos | Smile Up",
    seoDescription:
      "Brackets estéticos y cerámicos en Cusco: ventajas, cuidados y diferencias con los metálicos. Ortodoncia discreta para adolescentes y adultos.",
    coverTheme: "peach",
    content: [
      {
        type: "p",
        text: "Los brackets estéticos combinan la precisión de la ortodoncia fija con una apariencia más discreta. En consulta los valoro cuando el paciente —especialmente adolescentes y adultos— prioriza la estética durante el tratamiento.",
      },
      { type: "h3", text: "Diferencias con los brackets metálicos" },
      {
        type: "ul",
        items: [
          "Color similar al diente: menos notorios en fotos y reuniones.",
          "Misma mecánica de movimiento dental que los metálicos en la mayoría de casos.",
          "Requieren cuidado extra con alimentos que manchan (café, vino, curry).",
          "Pueden ser ligeramente más frágiles; conviene evitar morder alimentos muy duros directamente.",
        ],
      },
      { type: "h3", text: "¿Son para ti?" },
      {
        type: "p",
        text: "Si tu caso es moderado a complejo y valoras la discreción, los brackets estéticos suelen ser una excelente alternativa. En la evaluación comparo esta opción con alineadores invisibles según tu mordida y estilo de vida.",
      },
    ],
  },
  {
    slug: "alineadores-invisibles-cusco",
    coverImage: imgInvisalign,
    locale: "es",
    serviceFocus: ["orthodontics"],
    title: "Alineadores invisibles en Cusco: Invisalign y ortodoncia removible",
    date: "2026-06-02",
    readTime: "5 min",
    excerpt:
      "Alineadores transparentes planificados digitalmente: cómodos, removibles y discretos. Ideal para muchos casos de apiñamiento y mordida leve.",
    seoTitle: "Alineadores invisibles Cusco | Invisalign | Smile Up",
    seoDescription:
      "Alineadores invisibles e Invisalign en Cusco: cómo funcionan, ventajas, cuidados y para quién son indicados. Ortodoncia digital con el Dr. Paniura.",
    coverTheme: "mint",
    content: [
      {
        type: "p",
        text: "Los alineadores invisibles son placas removibles y transparentes que mueven los dientes de forma progresiva. En Smile Up utilizo planificación digital para simular el resultado antes de iniciar el tratamiento.",
      },
      { type: "h3", text: "Ventajas principales" },
      {
        type: "ul",
        items: [
          "Apariencia discreta: casi imperceptibles en el día a día.",
          "Se retiran para comer y cepillarse, lo que facilita la higiene.",
          "Cómodos y sin alambres ni brackets visibles.",
          "Planificación 3D que permite visualizar la evolución de la sonrisa.",
        ],
      },
      { type: "h3", text: "Compromiso del paciente" },
      {
        type: "p",
        text: "Los alineadores deben usarse entre 20 y 22 horas al día para que el tratamiento funcione. Son excelentes para adultos y adolescentes responsables; en casos muy complejos puede ser preferible la ortodoncia fija.",
      },
      {
        type: "note",
        text: "Atiendo pacientes locales e internacionales en Cusco. Con alineadores puedo entregar varias etapas si tu estancia es limitada.",
      },
    ],
  },
  {
    slug: "cuidados-brackets-ortodoncia",
    coverImage: imgCuscoBrackets,
    locale: "es",
    serviceFocus: ["orthodontics"],
    title: "Cuidados con brackets: guía práctica durante tu ortodoncia",
    date: "2026-05-28",
    readTime: "4 min",
    excerpt:
      "Evita emergencias y acelera tu tratamiento con estos cuidados diarios mientras llevas brackets metálicos o estéticos.",
    seoTitle: "Cuidados con brackets | Ortodoncia Cusco | Smile Up",
    seoDescription:
      "Cuidados esenciales con brackets: higiene, alimentación, elásticos y revisiones. Guía del especialista en ortodoncia en Cusco.",
    coverTheme: "sky",
    content: [
      {
        type: "p",
        text: "Un buen cuidado de los brackets reduce caries, inflamación de encías y despegues de brackets. Estos hábitos marcan la diferencia durante todo tu tratamiento de ortodoncia.",
      },
      { type: "h3", text: "Cuidados diarios" },
      {
        type: "ul",
        items: [
          "Cepilla después de cada comida; no dejes restos alrededor del bracket.",
          "Usa hilo dental con pasador o irrigador si tu ortodoncista lo recomienda.",
          "Asiste a todos los controles programados: los ajustes son parte del plan.",
          "Usa los elásticos según indicación; no los cambies por tu cuenta.",
          "Si un bracket se despega o un alambre molesta, contacta a la clínica sin esperar.",
        ],
      },
      { type: "h3", text: "Después del tratamiento" },
      {
        type: "p",
        text: "Al retirar los brackets se colocan retenedores para mantener el resultado. Saltarse la fase de retención es una de las causas más frecuentes de recaída.",
      },
    ],
  },
  {
    slug: "cepillado-dental-con-brackets",
    coverImage: imgJovenOrtodoncia,
    locale: "es",
    serviceFocus: ["orthodontics"],
    title: "Cepillado dental con brackets: técnica paso a paso",
    date: "2026-05-24",
    readTime: "4 min",
    excerpt:
      "Con brackets, el cepillado requiere más tiempo y técnica. Aprende a limpiar bien alrededor de cada bracket y proteger tus encías.",
    seoTitle: "Cepillado con brackets | Higiene ortodoncia Cusco | Smile Up",
    seoDescription:
      "Cómo cepillarse correctamente con brackets: técnica, cepillo interdental, hilo y errores comunes. Ortodoncia en Cusco.",
    coverTheme: "mint",
    content: [
      {
        type: "p",
        text: "Con brackets, la placa bacteriana se acumula con más facilidad alrededor de los brackets y los alambres. Un cepillado deficiente puede causar manchas blancas, caries y encías inflamadas.",
      },
      { type: "h3", text: "Técnica recomendada" },
      {
        type: "ul",
        items: [
          "Usa cepillo de cerdas suaves o cepillo ortodóncico en forma de V.",
          "Cepilla en ángulo hacia la encía y luego hacia el bracket (2–3 minutos).",
          "Pasa el cepillo interdental entre brackets y alambres.",
          "Complementa con hilo dental usando pasador o irrigador de agua.",
          "Cepilla la lengua y usa enjuague sin alcohol si lo indico en consulta.",
        ],
      },
      {
        type: "note",
        text: "Si sangran las encías al cepillarte las primeras semanas, suele deberse a inflamación por placa. Mejora con técnica constante; si persiste, agenda revisión.",
      },
    ],
  },
  {
    slug: "que-comer-con-brackets",
    coverImage: imgCuidadoBrackets,
    locale: "es",
    serviceFocus: ["orthodontics"],
    title: "¿Qué comer y qué no comer con brackets?",
    date: "2026-05-20",
    readTime: "4 min",
    excerpt:
      "Alimentos permitidos, prohibidos y consejos para no despegar brackets ni dañar los alambres durante tu ortodoncia.",
    seoTitle: "Qué comer con brackets | Alimentación ortodoncia Cusco",
    seoDescription:
      "Guía de alimentación con brackets: qué comer, qué evitar y cómo proteger tu ortodoncia. Consejos del Dr. Paniura en Cusco.",
    coverTheme: "peach",
    content: [
      {
        type: "p",
        text: "La alimentación con brackets no tiene que ser restrictiva, pero sí inteligente. Morder alimentos muy duros o pegajosos es la causa más frecuente de brackets despegados y visitas de urgencia.",
      },
      { type: "h3", text: "Alimentos recomendados" },
      {
        type: "ul",
        items: [
          "Carnes blandas, pescado, huevos y legumbres bien cocidas.",
          "Frutas en trozos pequeños o en puré (plátano, papaya, manzana cocida).",
          "Verduras cocidas, arroz, pasta, quinua y pan sin corteza dura.",
          "Lácteos, yogur y quesos blandos.",
        ],
      },
      { type: "h3", text: "Alimentos a evitar o moderar" },
      {
        type: "ul",
        items: [
          "Palomitas, nueces, chicharrón, huesos y hielo mordido.",
          "Chicles, caramelos duros, regaliz y gomitas pegajosas.",
          "Pan duro, galletas muy crujientes y manzana entera mordida.",
          "Bebidas azucaradas frecuentes: aumentan el riesgo de caries con brackets.",
        ],
      },
      {
        type: "note",
        text: "Corta la comida en trozos pequeños y mastica con molares. Si un bracket se despega, guarda la pieza y llama a la clínica.",
      },
    ],
  },
  {
    slug: "ortopedia-maxilar-ninos-edades",
    coverImage: imgOrtopediaMaxilar,
    locale: "es",
    serviceFocus: ["orthodontics"],
    title: "Ortopedia maxilar en niños: edades, usos y beneficios",
    date: "2026-05-16",
    readTime: "5 min",
    excerpt:
      "La ortopedia maxilar guía el crecimiento de los maxilares en la infancia. Conoce en qué edades se indica y qué problemas puede prevenir.",
    seoTitle: "Ortopedia maxilar niños Cusco | Edades y tratamiento | Smile Up",
    seoDescription:
      "Ortopedia maxilar en niños: edad ideal, aparatos, indicaciones y beneficios. Ortodoncia infantil en Cusco con el Dr. Paniura.",
    coverTheme: "sky",
    content: [
      {
        type: "p",
        text: "La ortopedia maxilar interviene mientras el niño aún está en crecimiento. Permite corregir o guiar el desarrollo de los maxilares antes de que la ortodoncia con brackets sea la fase principal del tratamiento.",
      },
      { type: "h3", text: "¿A qué edad se evalúa?" },
      {
        type: "p",
        text: "La primera evaluación ortodóncica en niños se recomienda alrededor de los 7 años, cuando comienzan a erupcionar los incisivos permanentes. No todos necesitan tratamiento inmediato, pero detectar a tiempo mordidas cruzadas, paladar estrecho o prognatismo permite actuar en el momento óptimo.",
      },
      { type: "h3", text: "Usos frecuentes de la ortopedia maxilar" },
      {
        type: "ul",
        items: [
          "Expandir el paladar en niños con maxilar superior estrecho.",
          "Corregir mordida cruzada anterior o posterior.",
          "Guiar el crecimiento en casos de prognatismo o retrognatia leve.",
          "Preparar espacio para la erupción de caninos y premolares.",
          "Intervenir en hábitos como succión digital prolongada cuando afectan el desarrollo.",
        ],
      },
      {
        type: "note",
        text: "La ortopedia maxilar no reemplaza siempre a los brackets; muchas veces es la primera fase de un plan por etapas que continúa en la adolescencia.",
      },
    ],
  },
  {
    slug: "edad-iniciar-ortodoncia",
    coverImage: imgNinosOrtodoncia,
    locale: "es",
    serviceFocus: ["orthodontics"],
    title: "¿A qué edad es bueno iniciar un tratamiento de ortodoncia?",
    date: "2026-05-12",
    readTime: "4 min",
    excerpt:
      "No existe una sola edad ideal para todos. Te explico cuándo conviene empezar en niños, adolescentes y adultos.",
    seoTitle: "¿A qué edad iniciar ortodoncia? | Niños y adultos Cusco",
    seoDescription:
      "Edad ideal para iniciar ortodoncia: niños, adolescentes y adultos. Cuándo evaluar, ortopedia maxilar y brackets en Cusco.",
    coverTheme: "mint",
    content: [
      {
        type: "p",
        text: "Una de las preguntas más frecuentes en consulta es cuándo empezar ortodoncia. La respuesta depende del tipo de problema: algunos casos se benefician de intervención temprana y otros de esperar el recambio dentario completo.",
      },
      { type: "h3", text: "Por etapas de la vida" },
      {
        type: "ul",
        items: [
          "Niños (6–10 años): evaluación y, si corresponde, ortopedia maxilar para guiar el crecimiento.",
          "Adolescentes (11–17 años): etapa clásica para brackets o alineadores; dentición permanente casi completa.",
          "Adultos (18+ años): nunca es tarde si las encías y el hueso están sanos; los tiempos pueden ser similares a los de un adolescente.",
        ],
      },
      { type: "h3", text: "Señales para adelantar la consulta" },
      {
        type: "ul",
        items: [
          "Dientes apiñados o espacios marcados.",
          "Mordida cruzada, abierta o sobremordida excesiva.",
          "Respiración bucal, ronquidos o dificultad para morder.",
          "Pérdida prematura de dientes de leche.",
        ],
      },
      {
        type: "note",
        text: "En Smile Up la primera evaluación aclara si conviene iniciar ya, esperar una fase de crecimiento o derivar estudios complementarios.",
      },
    ],
  },
  {
    slug: "ortodoncia-adultos-cusco",
    coverImage: imgOrtodonciaCusco,
    locale: "es",
    serviceFocus: ["orthodontics"],
    title: "Ortodoncia en adultos en Cusco: nunca es tarde para alinear tu sonrisa",
    date: "2026-05-08",
    readTime: "5 min",
    excerpt:
      "Más adultos eligen ortodoncia cada año. Brackets estéticos, metálicos o alineadores: opciones reales para mejorar mordida y estética.",
    seoTitle: "Ortodoncia adultos Cusco | Brackets y alineadores | Smile Up",
    seoDescription:
      "Ortodoncia para adultos en Cusco: opciones, tiempos, estética y salud periodontal. Brackets estéticos, metálicos e Invisalign.",
    coverTheme: "peach",
    content: [
      {
        type: "p",
        text: "La ortodoncia en adultos es cada vez más habitual. Ya sea por estética, preparación para prótesis, mejora de la mordida o corrección de recaídas, los adultos en Cusco buscan soluciones discretas y eficaces.",
      },
      { type: "h3", text: "Opciones para adultos" },
      {
        type: "ul",
        items: [
          "Brackets estéticos: discretos y fijos, adecuados para casos moderados a complejos.",
          "Brackets metálicos: máxima eficacia y menor costo en muchos planes.",
          "Alineadores invisibles: removibles, ideales si buscas discreción y puedes cumplir el uso diario.",
        ],
      },
      { type: "h3", text: "Salud de encías y hueso" },
      {
        type: "p",
        text: "Antes de iniciar evalúo el estado periodontal. Unas encías sanas son fundamentales para mover dientes de forma segura en cualquier edad. Si hay inflamación, tratamos primero ese aspecto.",
      },
      {
        type: "note",
        text: "Atiendo en español e inglés a pacientes locales, nacionales e internacionales en Av. La Cultura 822, Cusco.",
      },
    ],
  },
  {
    slug: "armonia-facial-ortodoncia",
    coverImage: imgFilosofia,
    locale: "es",
    serviceFocus: ["orthodontics"],
    title: "Impacto de la ortodoncia en la armonía facial",
    date: "2026-05-04",
    readTime: "5 min",
    excerpt:
      "La ortodoncia no solo alinea dientes: puede mejorar el perfil, la simetría y la proporción facial cuando el plan lo contempla.",
    seoTitle: "Armonía facial y ortodoncia | Perfil y sonrisa Cusco",
    seoDescription:
      "Cómo la ortodoncia influye en la armonía facial: perfil, labios, sonrisa y simetría. Ortodoncia integral en Cusco con el Dr. Paniura.",
    coverTheme: "sky",
    content: [
      {
        type: "p",
        text: "La armonía facial es el equilibrio entre nariz, labios, mentón y sonrisa. Un plan de ortodoncia bien diseñado no solo endereza dientes: puede mejorar la proyección de los labios, el perfil lateral y la sonrisa en conjunto.",
      },
      { type: "h3", text: "¿Cómo influye la ortodoncia?" },
      {
        type: "ul",
        items: [
          "Corrección de sobremordida: los labios pueden verse más equilibrados al reposo.",
          "Mordida abierta: cerrar el espacio anterior mejora la sonrisa y la función al hablar y comer.",
          "Apiñamiento severo: alinear los dientes amplía la arcada y mejora el soporte labial.",
          "Problemas esqueléticos leves: la ortopedia maxilar en niños puede guiar el crecimiento facial.",
        ],
      },
      { type: "h3", text: "Planificación integral" },
      {
        type: "p",
        text: "En la evaluación analizo fotografías de perfil, frente y sonrisa, junto con radiografías y modelos o escaneo digital. Así definimos un objetivo que combine función, estética dental y armonía facial.",
      },
      {
        type: "note",
        text: "En casos esqueléticos severos puede requerirse un plan combinado con cirugía ortognática. Te explico todas las alternativas sin tecnicismos innecesarios.",
      },
    ],
  },
  {
    slug: "retenedores-ortodoncia-cusco",
    coverImage: imgRetenedores,
    locale: "es",
    serviceFocus: ["orthodontics"],
    title: "Retenedores tras la ortodoncia: cómo conservar tu nueva sonrisa",
    date: "2026-05-01",
    readTime: "4 min",
    excerpt:
      "Terminar los brackets o alineadores no es el final: los retenedores evitan que los dientes vuelvan a moverse.",
    seoTitle: "Retenedores ortodoncia Cusco | Mantén tu sonrisa | Smile Up",
    seoDescription:
      "Retenedores fijos y removibles tras ortodoncia en Cusco: tipos, uso y duración. Evita recaídas después de brackets o alineadores.",
    coverTheme: "mint",
    content: [
      {
        type: "p",
        text: "Los dientes tienen memoria y tienden a volver a su posición original. Por eso la fase de retención es tan importante como el tratamiento activo con brackets o alineadores.",
      },
      { type: "h3", text: "Tipos de retenedores" },
      {
        type: "ul",
        items: [
          "Retenedor fijo: alambre adherido por la cara interna de los incisivos inferiores (o superiores).",
          "Retenedor removible tipo Hawley o placa transparente: se usa según horario indicado.",
          "A veces combino ambos para mayor estabilidad.",
        ],
      },
      {
        type: "note",
        text: "El incumplimiento de la retención es la causa más frecuente de recaída. Sigue las indicaciones y asiste a los controles de retención.",
      },
    ],
  },
  {
    slug: "dental-emergency-cusco-tourists",
    coverImage: imgSensibilidad,
    locale: "en",
    serviceFocus: ["emergency"],
    title: "Dental emergency in Cusco: what tourists should do",
    date: "2026-08-11",
    readTime: "6 min",
    excerpt:
      "Toothache, a broken tooth or swelling while traveling in Cusco? How to find an English-speaking emergency dentist and what to do before you arrive.",
    seoTitle: "Dental Emergency in Cusco for Tourists | Smile Up",
    seoDescription:
      "What to do if you have a dental emergency in Cusco: toothache, broken tooth, swelling. English-speaking same-day care at Smile Up, Av. La Cultura 822.",
    coverTheme: "peach",
    relatedLinks: [
      { to: "/emergency-dentist-cusco", label: "Emergency dentist in Cusco" },
    ],
    content: [
      {
        type: "p",
        text: "A sudden toothache in Cusco is more common than many travelers expect. High altitude, cold drinks, long walking days and delayed meals can turn a quiet dental problem into a trip-stopping emergency. The good news: you can usually see an English-speaking emergency dentist in Cusco the same day.",
      },
      { type: "h3", text: "Is it a true dental emergency?" },
      {
        type: "p",
        text: "Seek urgent dental care if pain is getting worse, you cannot sleep, a tooth has broken, a filling or crown came out, or your face or gum is swelling. Those problems rarely improve on a bus to Machu Picchu.",
      },
      {
        type: "ul",
        items: [
          "Severe or night-time toothache",
          "Broken, cracked or knocked tooth",
          "Lost filling, crown or temporary",
          "Swelling, pus or fever",
          "A poking braces wire or lost aligner",
        ],
      },
      { type: "h3", text: "What to do before you reach the clinic" },
      {
        type: "ul",
        items: [
          "Rinse with warm water and avoid very hot, cold or hard foods.",
          "Use a cold compress on the cheek for swelling, 10–15 minutes on and off.",
          "Do not put aspirin on the gum — it can burn the tissue.",
          "Send a WhatsApp photo if you can. A short description helps the clinic judge urgency.",
        ],
      },
      {
        type: "note",
        text: "Go to a hospital emergency department first if you have trouble breathing or swallowing, rapidly spreading facial swelling, uncontrolled bleeding, or head trauma with dizziness.",
      },
      { type: "h3", text: "Why altitude can make tooth pain feel worse" },
      {
        type: "p",
        text: "Cusco sits at high altitude. Sinus pressure and existing tooth inflammation can feel sharper than at sea level. An exam helps tell a dental infection apart from sinus-related pain so you are not treating the wrong problem.",
      },
      { type: "h3", text: "Same-day care at Smile Up" },
      {
        type: "p",
        text: "Smile Up is at Av. La Cultura 822, Wanchaq — a short ride from the historic center. We focus on relieving pain, protecting the tooth and explaining in English what must be done now versus what can wait until you see your dentist at home.",
      },
      {
        type: "cta",
        text: "Open the emergency dentist page",
        to: "/emergency-dentist-cusco",
      },
    ],
  },
  {
    slug: "orthodontics-cusco-braces-aligners",
    coverImage: imgBracketsMetalicos,
    locale: "en",
    serviceFocus: ["orthodontics"],
    title: "Orthodontics in Cusco: braces vs aligners (and what's best for you)",
    date: "2026-03-22",
    readTime: "5 min",
    excerpt:
      "A quick comparison of braces and clear aligners, what they treat, and how to start an orthodontic plan in Cusco.",
    seoTitle: "Orthodontics Cusco | Braces & Clear Aligners | Smile Up",
    seoDescription:
      "Orthodontic treatment in Cusco, Peru: braces vs aligners, common bite problems, and how to start your plan with Dr. Paniura.",
    coverTheme: "peach",
    content: [
      {
        type: "p",
        text: "Orthodontics improves bite and smile aesthetics. The best option depends on your case, timing, and comfort preferences.",
      },
      { type: "h3", text: "Braces" },
      {
        type: "ul",
        items: [
          "Great for complex movements and bite correction",
          "Fixed appliance (less reliance on patient compliance)",
          "Regular adjustments",
        ],
      },
      { type: "h3", text: "Clear aligners" },
      {
        type: "img",
        src: imgInvisalign,
        alt: "Invisalign clear aligners orthodontic treatment in Cusco",
      },
      {
        type: "ul",
        items: [
          "More discreet appearance",
          "Must be worn consistently to work well",
          "Ideal for many mild-to-moderate cases",
        ],
      },
      {
        type: "note",
        text: "At Smile Up we can do initial records and plan your treatment, then coordinate follow-ups depending on your schedule.",
      },
    ],
  },
];

export function getBlogPostBySlug(slug) {
  return blogPosts.find((p) => p.slug === slug);
}

/** Últimos posts por fecha (más reciente primero) */
export function getRecentBlogPosts(count = 3) {
  return [...blogPosts]
    .sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0))
    .slice(0, count);
}
